import React from "react";
import { useBLE } from "../../../hooks/useBle"; // Adjust path as needed

interface ModeSelectorProps {
  isAuto: boolean;
  onModeToggle?: () => void;
  isShortHeight: boolean;
}

const ModeSelector: React.FC<ModeSelectorProps> = ({
  isAuto,
  onModeToggle,
  isShortHeight,
}) => {
  // Get BLE context data
  const { isConnected, therapyParams, manualCycleNumber, currentProfileName } =
    useBLE();

  // Get cycle number based on mode
  const getCycleDisplay = (): string => {
    if (!isConnected) {
      return "0";
    }

    if (isAuto) {
      // Auto mode: show currentCycleNumber/totalCycleCount
      const currentCycle = therapyParams?.currentCycleNumber || 0;
      const totalCycles = therapyParams?.totalCycleCount || 0;
      return `${totalCycles - currentCycle + 1}/${totalCycles}`;
    } else {
      // Manual mode: show manualCycleNumber
      return String(manualCycleNumber || 0);
    }
  };

  // Get mode text with profile name
  const getModeText = (): string => {
    const mode = isAuto ? "Auto mode" : "Manual mode";
    const profileName =
      isConnected && currentProfileName ? currentProfileName : "";
    return profileName ? `${mode} (${profileName})` : mode;
  };

  // Get colors based on connection state
  const getColors = () => {
    if (isConnected) {
      return {
        modeTextColor: "#FFFFFF", // Bright white
        cycleTextColor: "#6B7280", // Gray for "Cycle" label
        cycleNumberColor: "#00FFFF", // Bright cyan for cycle number
        backgroundColor: "#374151", // Dark gray background for cycle badge
      };
    } else {
      return {
        modeTextColor: "#666666", // Dimmed for disconnected
        cycleTextColor: "#4B5563", // Darker gray for "Cycle" label
        cycleNumberColor: "#666666", // Dimmed cyan for cycle number
        backgroundColor: "#2D3748", // Darker background for cycle badge
      };
    }
  };

  const colors = getColors();
  const cycleDisplay = getCycleDisplay();
  const modeText = getModeText();

  return (
    <div
      className={`flex justify-between items-center ${
        isShortHeight ? "mb-1" : "mb-4"
      }`}
    >
      <span
        className="font-medium text-base cursor-pointer"
        style={{
          color: colors.modeTextColor,
          transition: "color 0.3s ease",
        }}
        // onClick={onModeToggle}
      >
        {modeText}
      </span>

      <div
        className="flex items-center gap-2 px-4 py-2"
        style={{
          // backgroundColor: colors.backgroundColor,
          transition: "background-color 0.3s ease",
        }}
      >
        <span
          className="text-sm"
          style={{
            color: colors.modeTextColor,
            transition: "color 0.3s ease",
          }}
        >
          Cycle
        </span>
        <span
          className="font-bold text-lg"
          style={{
            color: colors.cycleNumberColor,
            transition: "color 0.3s ease",
          }}
        >
          {cycleDisplay}
        </span>
      </div>
    </div>
  );
};

export default ModeSelector;
